<template>
    <st-filters-pagination
        stateModule="applicationType/list"
        :filters="filters"
        :total="total"
        @change="doFilter"
        :header="$t('APPLICATION_TYPE.LIST.TITLE')"
        :moreFilters="false"
    >
        <slot></slot>
    </st-filters-pagination>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FilterSchema } from '@/shared/form/filter-schema';
    import { ApplicationTypeModel } from '@/modules/application-type/application-type-model';

    const { fields } = ApplicationTypeModel;

    const filterSchema = new FilterSchema([
        fields.name,
        fields.status,
    ]);

    export default {
        name: 'ApplicationTypeListFilter',
        data() {
            return {
                filters: filterSchema.fields,
                currentPage: 1,
            };
        },
        computed: {
            ...mapGetters({
               total: 'applicationType/list/total',
            }),
        },
        methods: {
            ...mapActions({
                doFetch: 'applicationType/list/doFetch',
            }),
            async doFilter(params) {
                this.doFetch(params);
            },
        },

    };
</script>

<style scoped>

</style>
